/**
 * Production environment
 */
export const environment = {
  production: true,
  baseUrl: 'https://cardbro.cardcompact.com/api/',
  apiUrl: 'https://cardbro.cardcompact.com/api/uploads/',
  frontendBaseUrl: 'https://cardbro.cardcompact.com/',
};
